import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import { bmiClass } from "../Util/enum";

const emptyState = { peso: '', altezza: '', bmi: '', bmi_class: '', piede: '', data: '' };

const Ro = ({ label, value }) => (
    <Col lg={2}>
        <Form.Group className="mb-0">
            <Form.Label>{label}</Form.Label>
            <Form.Control className="sid-ro-input" type="text" value={value || ''} readOnly tabIndex={-1} />
        </Form.Group>
    </Col>
);

const FormaFisPlayer = (props) => {

    const [state, setState] = useState(emptyState);

    useEffect(() => {
        const p = props.privateProfile && props.privateProfile.idsPlay;
        if (!p || !Array.isArray(p.states) || p.states.length === 0) {
            setState(emptyState);
            return;
        }

        // Ultimo stato per updatedAt
        const latest = p.states.reduce((a, b) => ((a.updatedAt || 0) > (b.updatedAt || 0) ? a : b));

        const bmiLabel = (() => {
            const found = bmiClass.find((el) => el.value === latest.bodyMassIndexClass);
            return found ? found.label : '';
        })();

        const dataAgg = latest.updatedAt
            ? new Date(latest.updatedAt).toLocaleDateString('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' })
            : '';

        setState({
            peso: latest.weight != null ? `${latest.weight} kg` : '',
            altezza: latest.height != null ? `${latest.height} cm` : '',
            bmi: latest.bodyMassIndex != null ? Number(latest.bodyMassIndex).toFixed(1).replace('.', ',') : '',
            bmi_class: bmiLabel,
            piede: latest.footNumber != null ? String(latest.footNumber) : '',
            data: dataAgg,
        });
    }, [props.privateProfile]);

    return (
        <Card>
            <Card.Header><Card.Title>Forma fisica</Card.Title></Card.Header>
            <Card.Body>
                <Row className="mt-3">
                    <Ro label="Peso" value={state.peso} />
                    <Ro label="Altezza" value={state.altezza} />
                    <Ro label="BMI" value={state.bmi} />
                    <Ro label="Classe BMI" value={state.bmi_class} />
                    <Ro label="N° Piede" value={state.piede} />
                    <Ro label="Data aggiornamento" value={state.data} />
                </Row>
            </Card.Body>
        </Card>
    );
};

export default FormaFisPlayer;
